import { jsxs as e, jsx as a } from "react/jsx-runtime";
import "react";
const m = _ref => {
    let {
      rating: s,
      totalReviews: t,
      hideRating: l = !1,
      hideTotal: n = !1,
      className: i,
      ...r
    } = _ref;
    return /* @__PURE__ */e("div", {
      className: `sash-starRatings relative inline-flex items-center ${i || ""}`,
      ...r,
      children: [s && !l && /* @__PURE__ */a("p", {
        className: "sash-starRatings-Rating mr-2 text-sm font-semibold !leading-none md:mr-3 md:text-2xl",
        children: s
      }), /* @__PURE__ */e("div", {
        className: "grid grid-cols-1 grid-rows-1",
        children: [/* @__PURE__ */e("span", {
          className: "sash-starRatings-Filled col-[1] row-[1] flex flex-row overflow-hidden whitespace-nowrap text-black",
          style: {
            width: `calc( ( ${s} / 5 ) * 100% )`
          },
          children: [/* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            style: {
              fontVariationSettings: "'FILL' 1"
            },
            children: "star"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            style: {
              fontVariationSettings: "'FILL' 1"
            },
            children: "star"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            style: {
              fontVariationSettings: "'FILL' 1"
            },
            children: "star"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            style: {
              fontVariationSettings: "'FILL' 1"
            },
            children: "star"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            style: {
              fontVariationSettings: "'FILL' 1"
            },
            children: "star"
          })]
        }), /* @__PURE__ */e("span", {
          className: "sash-starRatings-Unfilled col-[1] row-[1] flex flex-row overflow-hidden whitespace-nowrap text-black",
          children: [/* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            children: "star_outline"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            children: "star_outline"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            children: "star_outline"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            children: "star_outline"
          }), /* @__PURE__ */a("span", {
            className: "material-symbols-sharp text-lg !leading-none md:text-3xl",
            children: "star_outline"
          })]
        })]
      }), t && !n && /* @__PURE__ */e("p", {
        className: "sash-starRatings-Total ml-2 text-sm !leading-none md:ml-3 md:text-sm",
        children: [t, " Reviews"]
      })]
    });
  },
  x = m;
export { x as default };